<div #invoice id="invoice" class="invoice-wrapper">
  <h2>Invoice</h2>
  <p><strong>Invoice #: </strong>{{ invoiceData.invoiceNumber }}</p>
  <p><strong>Date: </strong>{{ invoiceData.date }}</p>
  <p><strong>Customer: </strong>{{ invoiceData.customer }}</p>

  <table>
    <thead>
      <tr>
        <th>Item</th>
        <th>Quantity</th>
        <th>Price</th>
        <th>Total</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of invoiceData.items">
        <td>{{ item.name }}</td>
        <td>{{ item.quantity }}</td>
        <td>{{ item.price | currency }}</td>
        <td>{{ item.quantity * item.price | currency }}</td>
      </tr>
    </tbody>
  </table>

  <h3 class="total">Grand Total: {{ getTotal() | currency }}</h3>
</div>

<!-- Button OUTSIDE the invoice -->
<button (click)="downloadPDF()">Download PDF</button>
